import React, { useEffect, useState } from 'react'
import { ApplicationsListInterface } from '../../../modules/accounts/components/settings/SettingsModel'
import { useNavigate } from 'react-router-dom'
import { useMutation, useQuery } from 'react-query'
import { delete_application, get_all_applications, single_application_log } from '../api/applicationsApi'
import { toast } from 'react-toastify'
import { Card } from 'react-bootstrap'
import { KTIcon, KTSVG } from '../../../../_metronic/helpers'
import "../../../../_metronic/assets/keenicons/solid/style.css";
import { permissionCheck } from '../../../helper-functions/PermissionCheck'
import { formatDateWithTime } from '../../../helper-functions/DateFunction'
var application_create, application_update, application_delete, application_view, application_activity_log
function ApplicationsList() {
    const [applicationsList, setApplicationsList] = useState<ApplicationsListInterface[]>([])
    const [selectedApplication, setSelectedApplication] = useState<ApplicationsListInterface>()
    const navigate = useNavigate()
    application_create = Boolean(permissionCheck('application-create'));
    application_update = Boolean(permissionCheck('application-update'));
    application_delete = Boolean(permissionCheck('application-delete'));
    application_view = Boolean(permissionCheck('application-view'));
    application_activity_log = Boolean(permissionCheck('application-activity-log'));
    const { data: applicationsData, isLoading } = useQuery('applications', get_all_applications, {
        refetchOnWindowFocus: false,
    })
    useEffect(() => {
        if (applicationsData) {
            setApplicationsList(applicationsData.data as ApplicationsListInterface[])
        }
    }, [applicationsData])
    const handleDeleteApplication = useMutation((id: number) => {
        return delete_application(id)
            .then((response) => {
                toast.success(response.message, {
                    position: 'top-right',
                    autoClose: 3000,
                })
            })
            .then(() => {
                return get_all_applications().then((data) => {
                    setApplicationsList(data.data);
                })
            })
            .catch((error: any) => {
                const errorMessage = error?.response?.data?.message || error?.message || 'Failed to delete application';
                toast.error(errorMessage, {
                    position: 'top-right',
                    autoClose: 2000,
                })
            });
    });
    if (isLoading) {
        return (
            <div className='text-center'>
                <div className='spinner-border' role='status'>
                    <span className='visually-hidden'>Loading...</span>
                </div>
            </div>
        );
    }
    const handleViewApplications = (organisation: any) => {
        navigate("/organisations/applications", { state: { organisation: organisation } });
    };
    const handleApplicationEdit = (application: any) => {
        navigate("/applications/edit-application", { state: { application: application } });
    };
    const handleApplicationActivityLog = (application: ApplicationsListInterface) => {
        navigate('/applications/activity-log', {
            state: { application_id: application.id }
        });
    };
    return (
        <>
            <div className='card card-xxl-stretch mx-4 mb-5 mb-xl-10'>
                <div className='card-header border-0 pt-5'>
                    <h3 className='card-title align-items-start flex-column'>
                        <span className='card-label fw-bold fs-3 mb-1'>List of Applications</span>
                    </h3>
                    {
                        application_create && (
                            <div
                                className='card-toolbar'
                                data-bs-toggle='tooltip'
                                data-bs-placement='top'
                                data-bs-trigger='hover'
                            >
                                <button
                                    data-toggle="tooltip" data-placement="bottom" title="Navigate to Add New Application"
                                    className='btn btn-sm btn-light-dark'
                                    onClick={() => navigate('/applications/add-application')}
                                >
                                    <KTIcon iconName='plus' className='fs-3' />
                                    Add Application
                                </button>
                            </div>
                        )
                    }
                </div>
                <div className='row g-3 p-5'>
                    {applicationsList.map((application, index) => (
                        <div className="col-lg-4 col-md-6 col-sm-12">
                            <Card
                                key={index}
                                className={`organisation-card h-100 position-relative border-3 
                                            ${application.status === 1 ? 'border-success' : 'border-secondary-subtle'}`}
                            >
                                <div
                                    className="position-absolute top-0 end-0 mt-2 me-2"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="left"
                                    title={application.status === 1 ? 'Active' : 'Inactive'}
                                >
                                    <i
                                        className={`bi bi-circle-fill fs-3 
                                    ${application.status === 1 ? 'text-success' : 'text-secondary'}`}
                                    ></i>
                                </div>
                                <Card.Body className="d-flex flex-column">
                                    <Card.Title className='d-flex justify-content-left text-primary'>
                                        {application.name}
                                    </Card.Title>
                                    <Card.Text className='m-0'>
                                        <b>Website URL: </b> {application.website_url}
                                    </Card.Text>
                                    <Card.Text className='m-0'>
                                        <b>API URL: </b> {application.api_url}
                                    </Card.Text>
                                    <Card.Text className='m-0'>
                                        <b>Updated At:</b> {formatDateWithTime(application.updated_at)}
                                    </Card.Text>
                                </Card.Body>
                                <Card.Footer className='d-flex justify-content-end'>
                                    {
                                        application_update && (
                                            <button
                                                data-toggle="tooltip" data-placement="bottom" title="Edit Application"
                                                className='btn btn-icon btn-light-dark btn-active-color-success btn-sm me-2'
                                                onClick={() => handleApplicationEdit({ ...application })}
                                            >
                                                <KTIcon iconName='pencil' className='fs-3' />
                                            </button>
                                        )
                                    }
                                    {
                                        application_view && (
                                            <button
                                                data-toggle="tooltip" data-placement="bottom" title="See Application's Details"
                                                data-bs-toggle='modal'
                                                data-bs-target='#kt_modal_2'
                                                onClick={() => setSelectedApplication(application)}
                                                className='btn btn-icon btn-light-dark btn-active-color-warning btn-sm me-1'
                                            >
                                                <KTIcon iconName='eye' className='fs-3' />
                                            </button>
                                        )
                                    }
                                    {
                                        1 && (
                                            <button
                                                data-toggle="tooltip"
                                                data-placement="bottom"
                                                title="View Activity Log"
                                                className='btn btn-icon btn-light-dark btn-active-color-info btn-sm'
                                                onClick={() => handleApplicationActivityLog(application)}
                                            >
                                                <KTIcon iconName='note' className='fs-3' />
                                            </button>
                                        )
                                    }
                                </Card.Footer>
                            </Card>
                        </div>
                    ))}
                </div>
            </div>
            {/* Delete modal */}
            <div className='modal fade' tabIndex={-1} id='kt_modal_1'>
                <div className='modal-dialog'>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h5 className='modal-title'>Delete Application Confirmation</h5>
                            <div
                                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                                data-bs-dismiss='modal'
                                aria-label='Close'
                            >
                                <KTSVG
                                    path='/media/icons/duotune/arrows/arr061.svg'
                                    className='svg-icon svg-icon-2x'
                                />
                            </div>
                        </div>
                        <div className='modal-body'>
                            {selectedApplication ? (
                                <>
                                    <p className='mb-2'>
                                        <span className='fw-bold'>Application Name: </span> {selectedApplication.name}
                                    </p>
                                    {selectedApplication.description ? (

                                        <p className='mb-2'>
                                            <span className='fw-bold'>Description: </span>{' '}
                                            {selectedApplication.description}
                                        </p>
                                    ) : null}
                                </>
                            ) : null}
                        </div>
                        <div className='modal-footer'>
                            <button data-toggle="tooltip" data-placement="bottom" title="close" type='button' className='btn btn-light' data-bs-dismiss='modal'>
                                Close
                            </button>
                            <button
                                data-toggle="tooltip" data-placement="bottom" title="Delete this Application"
                                type='button'
                                onClick={() => {
                                    if (selectedApplication && selectedApplication.id) {
                                        handleDeleteApplication.mutate(selectedApplication.id)
                                    }
                                }}
                                className='btn btn-danger'
                                data-bs-dismiss='modal'
                            >
                                Delete Application
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <div className='modal fade' tabIndex={-1} id='kt_modal_2'>
                <div className='modal-dialog modal-dialog-centered modal-lg'>
                    <div className='modal-content'>
                        <div className='modal-header'>
                            <h5 className='modal-title'>View Application</h5>
                            <div
                                className='btn btn-icon btn-sm btn-active-light-primary ms-2'
                                data-bs-dismiss='modal'
                                aria-label='Close'
                            >
                                <KTSVG
                                    path='/media/icons/duotune/arrows/arr061.svg'
                                    className='svg-icon svg-icon-2x'
                                />
                            </div>
                        </div>
                        <div className='modal-body'>
                            {selectedApplication ? (
                                <>
                                    <div className='form-group row mb-6'>
                                        <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                            <span className='required'>Application Name</span>
                                        </label>
                                        <div className='col-lg-8 fv-row mt-3'>
                                            <span>{selectedApplication.name}</span>
                                        </div>
                                    </div>
                                    <div className='form-group row mb-6'>
                                        <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                            <span className='required'>Frontend Domain Prefix</span>
                                        </label>
                                        <div className='col-lg-8 fv-row mt-3'>
                                            <span>{selectedApplication.frontend_domain_prefix}</span>
                                        </div>
                                    </div>
                                    <div className='form-group row mb-6'>
                                        <label className='col-lg-4 col-form-label fw-bold fs-6 '>
                                            <span className='required'>API Domain Prefix</span>
                                        </label>
                                        <div className='col-lg-8 fv-row mt-3'>
                                            <span>{selectedApplication.api_domain_prefix}</span>
                                        </div>
                                    </div>
                                    <div className='form-group row mb-6'>
                                        <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                            <span className='required'>Website URL</span>
                                        </label>
                                        <div className='col-lg-8 fv-row mt-3'>
                                            <span>{selectedApplication.website_url}</span>
                                        </div>
                                    </div>
                                    <div className='form-group row mb-6'>
                                        <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                            <span className='required'>API URL</span>
                                        </label>
                                        <div className='col-lg-8 fv-row mt-3'>
                                            <span>{selectedApplication.api_url}</span>
                                        </div>
                                    </div>
                                    <div className='form-group row mb-6'>
                                        <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                            <span className='required'>Server URL</span>
                                        </label>
                                        <div className='col-lg-8 fv-row mt-3'>
                                            <span>{selectedApplication.server_url}</span>
                                        </div>
                                    </div>
                                    <div className='form-group row mb-6'>
                                        <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                            <span>Description</span>
                                        </label>
                                        <div className='col-lg-8 fv-row mt-3'>
                                            <span>{selectedApplication.description}</span>
                                        </div>
                                    </div>
                                    <div className='form-group row mb-6'>
                                        <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                            <span>Favicon</span>
                                        </label>
                                        <div className='col-lg-8 fv-row mt-3'>
                                            <img
                                                src={selectedApplication.favicon}
                                                alt="Color Logo"
                                                className="img-fluid logo-application-img-icon bg-dark rounded"
                                            />
                                        </div>
                                    </div>
                                    <div className='form-group row mb-6'>
                                        <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                            <span>White Logo</span>
                                        </label>
                                        <div className='col-lg-8 fv-row mt-3'>
                                            <img
                                                src={selectedApplication.white_logo}
                                                alt='Logo'
                                                className="img-fluid logo-application-img bg-dark rounded"
                                            />
                                        </div>
                                    </div>
                                    <div className='form-group row mb-6'>
                                        <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                            <span>Coloured Logo</span>
                                        </label>
                                        <div className='col-lg-8 fv-row mt-3'>
                                            <img
                                                src={selectedApplication.colored_logo}
                                                alt='Logo'
                                                className="img-fluid logo-application-img rounded"
                                            />
                                        </div>
                                    </div>
                                    <div className='form-group row mb-6'>
                                        <label className='col-lg-4 col-form-label fw-bold fs-6'>
                                            <span>Status</span>
                                        </label>
                                        <div className='col-lg-8 fv-row mt-5'>
                                            <span>{selectedApplication.status == 1 ? 'Active' : 'Inactive'}</span>
                                        </div>
                                    </div>
                                </>
                            ) : null}
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ApplicationsList